const data = [
  {
    title: "Modal (Popup)",
    shortDescription:
      "A pop-up window. It sits on top of your app and forces the user to pay attention before doing anything else.",
    description:
      "This is the classic 'Are you sure you want to delete this?' box. Building this from scratch teaches you about 'Layers' in CSS. You create a dark, semi-transparent `<div>` (called a Backdrop) that covers the entire screen to block interactions. Then, you place your actual content box on top of it using `z-index`. It's also a great way to practice keyboard events, like listening for the 'Escape' key to close the window.",
  },
];

export default data;